import { render, staticRenderFns } from "./BaseEtymVarTable.vue?vue&type=template&id=0a466577&scoped=true&"
import script from "./BaseEtymVarTable.vue?vue&type=script&lang=js&"
export * from "./BaseEtymVarTable.vue?vue&type=script&lang=js&"
import style0 from "./BaseEtymVarTable.vue?vue&type=style&index=0&id=0a466577&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a466577",
  null
  
)

export default component.exports